export default "__VITE_ASSET__DkS6U37O__"